import { useTranslation } from 'react-i18next'
import { Languages } from 'lucide-react'

export default function LanguageSwitcher() {
  const { i18n } = useTranslation()

  const toggleLanguage = () => {
    const nextLang = i18n.language?.startsWith('en') ? 'fr' : 'en'
    i18n.changeLanguage(nextLang)
  }

  const currentLang = i18n.language?.startsWith('en') ? 'en' : 'fr'

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-1 px-3 py-1.5 text-sm font-medium text-gray-600 hover:text-primary-600 dark:text-gray-300 dark:hover:text-primary-400 transition-colors rounded-md hover:bg-gray-100 dark:hover:bg-gray-800"
      aria-label={`Changer la langue en ${currentLang === 'fr' ? 'anglais' : 'français'}`}
      title={currentLang === 'fr' ? 'Switch to English' : 'Passer en français'}
    >
      <Languages className="h-4 w-4" />
      <span>{currentLang === 'fr' ? 'EN' : 'FR'}</span>
    </button>
  )
}
